export default "__VITE_ASSET__dZtd_sKk__"